module.exports = __webpack_public_path__ + "files/ac402c3bdaed1d010f8ca18ed0f03daf.png";